export default __webpack_public_path__ + "static/media/Termice.18ffaa25.svg";